export const hasTabFocus = () => document.hasFocus();

export const getTabVisibility = () => document.visibilityState ?
    document.visibilityState === 'visible' :
    !(document.hidden || document.mozHidden || document.msHidden || document.webkitHidden);

export const isBrowserSupportVisibilityApi =
    !(typeof document.addEventListener === "undefined" || typeof document.hidden === "undefined");
